import styled from 'styled-components';
import { ReactComponent as CommonInfoIcon } from '../../assets/infotip.svg';

export const CommonInfoIconStyled = styled(CommonInfoIcon)`
  cursor: pointer;

  path {
    fill: ${({ theme }) => `${theme.palette.text.link}`};
  }

  path:nth-of-type(1) {
    fill: ${({ theme }) => `${theme.palette.text.link}12`};
  }
`;
